"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { sharedColors } from "ui/theme/colors"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const StyledNumbersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
`

const StyledConnectingLine = styled.div`
  position: absolute;
  top: 16px;
  left: 32px;
  right: 32px;
  height: 2px;
  background-color: ${sharedColors.borderGray};
  z-index: -1;
`

const StyledNumberBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const StyledNumber = styled.div<{ active: boolean }>`
  display: flex;
  width: 32px;
  height: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 26px;
  background-color: ${({ active }) =>
    active ? sharedColors.brandDark : sharedColors.borderGray};
  font-size: 20px;
  font-weight: 500;
  line-height: 140%;
  color: ${({ active }) => (active ? "white" : `${sharedColors.labelGray}`)};
`

export default function Stepper({
  step,
  steps,
}: {
  step: number
  steps: { stepName: string; icon: string; title: string; subTitle: string }[]
}) {
  return (
    <StyledLayout>
      <StyledNumbersContainer>
        <StyledConnectingLine />
        {steps.map((el, i) => (
          <StyledNumberBox key={i}>
            <StyledNumber active={step >= i + 1}>{i + 1}</StyledNumber>
            <Typography
              variant="body3"
              color={step >= 1 ? sharedColors.black : sharedColors.labelGray}
            >
              {el.stepName}
            </Typography>
          </StyledNumberBox>
        ))}
      </StyledNumbersContainer>
    </StyledLayout>
  )
}
